module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.4e17ada5.webp";